import queryString from 'query-string';
import { CALL_API } from 'middleware/api';
import { prepareParams } from 'features/invest/utils/prepareParams';
export const getBillingHistory = (paging) => ({
    [CALL_API]: {
        endpoint: `/premium/invoices?${queryString.stringify(prepareParams({ ...paging, perPage: 20 }))}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        extra: paging,
        types: [
            'GET_BILLING_HISTORY_REQUEST',
            'GET_BILLING_HISTORY_SUCCESS',
            'GET_BILLING_HISTORY_FAILURE',
        ],
    },
});
